import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import workflowSaveService from '../../../services/workflowSaveService';

const WorkflowAccessCard = ({ module, onNavigateToWorkflow }) => {
  const handleWorkflowNavigation = () => {
    // Check if workflow exists for this module
    const hasWorkflow = workflowSaveService?.hasWorkflowData(module?.id);
    onNavigateToWorkflow(hasWorkflow);
  };

  return (
    <div className="bg-card rounded-xl border border-border p-5">
      <div className="flex items-start justify-between gap-4">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-2">
            <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
              <Icon name="GitBranch" size={20} color="var(--color-primary)" />
            </div>
            <div>
              <h3 className="text-base font-semibold text-foreground">Workflow Management</h3>
              <p className="text-xs text-muted-foreground">Access and manage module workflow</p>
            </div>
          </div>
          
          <div className="mt-4 p-3 bg-muted/30 rounded-lg">
            <div className="flex items-center gap-2 mb-2">
              <Icon name="Info" size={14} color="var(--color-muted-foreground)" />
              <p className="text-xs font-medium text-foreground">Module Details</p>
            </div>
            <div className="grid grid-cols-3 gap-3 text-center">
              <div>
                <p className="text-xs text-muted-foreground mb-0.5">Allocated</p>
                <p className="text-sm font-semibold text-foreground">{module?.allocated || 0}</p>
              </div>
              <div>
                <p className="text-xs text-muted-foreground mb-0.5">Completed</p>
                <p className="text-sm font-semibold text-success">{module?.completed || 0}</p>
              </div>
              <div>
                <p className="text-xs text-muted-foreground mb-0.5">Remaining</p>
                <p className="text-sm font-semibold text-warning">{(module?.quantity || 0) - (module?.completed || 0)}</p>
              </div>
            </div>
          </div>
        </div>
        
        <div className="flex-shrink-0 flex items-center">
          <Button
            variant="default"
            size="lg"
            onClick={handleWorkflowNavigation}
            className="relative overflow-hidden group shadow-lg hover:shadow-xl transition-all duration-300"
          >
            <span className="relative z-10 flex items-center gap-2">
              <Icon name="Workflow" size={18} />
              <span className="font-semibold">Open Workflow Designer</span>
              <Icon name="ArrowRight" size={16} className="group-hover:translate-x-1 transition-transform duration-300" />
            </span>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default WorkflowAccessCard;